import { create } from "zustand";
import { chatbotStatus, CommonResponseModel, ReactionEmojiData, snackbarItem, whatsAppWebhookPayloadKey } from "../models/axiosModel";
import agent from "../services/api";
import { getGenericDataTypeList } from "../components/dashboard/channels/global/whatsapp/flows/whatsappFlowTypes";
import { AlertColor } from "@mui/material";

let snackbarIdCounter = 0;
const generateSnackbarId = () => {
    snackbarIdCounter += 1;
    return Date.now() * 1000 + (snackbarIdCounter % 1000);
};

interface genericStoreInterface {
    emojiList: ReactionEmojiData[] | null,
    setEmojiList: (value: ReactionEmojiData[] | null) => void,
    getEmojiListApiCall: () => Promise<CommonResponseModel<ReactionEmojiData>>,
    
    whatsAppWebhookPayloadKeys: whatsAppWebhookPayloadKey[] | null,
    setWhatsAppWebhookPayloadKeys: (value: whatsAppWebhookPayloadKey[] | null) => void,
    getWhatsAppWebhookPayloadKeyApi: () => Promise<CommonResponseModel<whatsAppWebhookPayloadKey>>, 

    genericDataTypeList: getGenericDataTypeList[] | null,
    setGenericDataTypeList: (value: getGenericDataTypeList[] | null) => void,

    getGenericDataTypeApi: () => Promise<CommonResponseModel<getGenericDataTypeList>>, 

    listOfChatbotStatus: chatbotStatus[] | null,
    setListOfChatbotStatus: (value: chatbotStatus[] | null) => void,
    getChatbotStatus: () => Promise<CommonResponseModel<chatbotStatus>>,

    snackbars: snackbarItem[],
    setSnackbars: (value: snackbarItem[]) => void,

    showSnackbar: (type: AlertColor, message: string) => void,

    removeSnackbar: (id: number) => void,

    showSuccess: (message: string) => void,

    showError: (message: string) => void,

    showInfo: (message: string) => void,
 
    showWarning: (message: string) => void,

    removeSuccessSnackbar: () => void,

    removeErrorSnackbar: () => void
}

export const useGenericStore = create<genericStoreInterface>((set, get) => {

    return {
        emojiList: null,
        setEmojiList: (value: ReactionEmojiData[] | null) => set({ emojiList: value }),
        getEmojiListApiCall: async () => {
            const res = await agent.getEmojiList.get();
            if (res?.status) {
              set({ emojiList: res.data });
            } else {
              set({ emojiList: null })
            }
            return res;
        },

        whatsAppWebhookPayloadKeys: null,
        setWhatsAppWebhookPayloadKeys: (value: whatsAppWebhookPayloadKey[] | null) => set({ whatsAppWebhookPayloadKeys: value }),

        getWhatsAppWebhookPayloadKeyApi: async () => {
            const res = await agent.getWebhookPayloadkey.get();
            if(res?.status){
                set({ whatsAppWebhookPayloadKeys: res?.data })
            } else {
                set({ whatsAppWebhookPayloadKeys: null })
            }
            return res;
        }, 

        genericDataTypeList: null,
        setGenericDataTypeList: (value: getGenericDataTypeList[] | null) => set({ genericDataTypeList: value }),

        getGenericDataTypeApi: async () => {
            const res = await agent.getGenericDataTypeList.get();

            if(res?.status){
                set({ genericDataTypeList: res?.data });
            } else {
                set({ genericDataTypeList: null });
            }
            return res;
        },

        listOfChatbotStatus: null,
        setListOfChatbotStatus: (value: chatbotStatus[] | null) => set({ listOfChatbotStatus: value }),

        getChatbotStatus: async () => {
            const res = await agent.getChatbotStatus.get(); 

            if(res?.status){
                set({ listOfChatbotStatus: res?.data });
            } else {
                set({ listOfChatbotStatus: null });
            }
            return res;
        },

        snackbars: [],
        setSnackbars: (value: snackbarItem[]) => set({ snackbars: value }),

        showSnackbar: (type: AlertColor, message: string) => {
            set((state) => ({
                snackbars: [
                    ...state.snackbars.filter((item) => item.message !== message),
                    {
                        id: generateSnackbarId(),
                        type,
                        message,
                    },
                ],
            }))
        },

        removeSnackbar: (id: number) => {
            set((state) => ({
                snackbars: state.snackbars.filter((item) => item.id !== id),
            }))
        },

        showSuccess: (message: string) => get().showSnackbar("success", message),

        showError: (message: string) => get().showSnackbar("error", message),

        showInfo: (message: string) => get().showSnackbar("info", message),

        showWarning: (message: string) => get().showSnackbar("warning", message),

        removeSuccessSnackbar: () => {
            set((state) => ({
                snackbars: state.snackbars.filter((item) => item.type !== "success"),
            }))
        },

        removeErrorSnackbar: () => {
            set((state) => ({
                snackbars: state.snackbars.filter((item) => item.type !== "error"),
            }))
        }
    }
});
